import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import $ from "jquery";

// Attach jQuery to window to fix $.fn error
window.$ = $;
window.jQuery = $;

// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel";

export const useHomeScript = () => {
  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 650,
      once: true,
    });

    // Offcanvas toggle
    const navbarToggle = document.querySelector("#navbarSideCollapse");
    if (navbarToggle) {
      navbarToggle.addEventListener("click", () => {
        document.querySelector(".offcanvas-collapse")?.classList.toggle("open");
      });
    }

    // Accordion functionality
    const accordianItemHeaders = document.querySelectorAll(
      ".accordian-item-header"
    );
    accordianItemHeaders.forEach(header => {
      header.addEventListener("click", () => {
        const current = document.querySelector(".accordian-item-header.active");

        if (current && current !== header) {
          current.classList.remove("active");
          current.nextElementSibling.style.maxHeight = 0;
        }

        header.classList.toggle("active");
        const body = header.nextElementSibling;
        if (header.classList.contains("active")) {
          body.style.maxHeight = body.scrollHeight + "px";
        } else {
          body.style.maxHeight = 0;
        }
      });
    });

    // Show image for accordion
    window.showImage = function(imageId) {
      const images = document.querySelectorAll(".accordion-image");
      images.forEach(img => (img.style.display = "none"));
      const imgElement = document.getElementById(imageId);
      if (imgElement) imgElement.style.display = "block";
    };

    // Owl Carousel initialization
    const carousels = [
      "#owl-carousel", "#owl-carousel1", "#owl-carousel2", "#owl-carousel3",
      "#owl-carousel4", "#owl-carousel5", "#owl-carousel6", "#owl-carousel7",
      "#owl-carousel8", "#owl-carousel9", "#owl-carousel10", "#eleven",
      "#twelve", "#threteen"
    ];

    carousels.forEach(id => {
      if ($(id).length) {
        $(id).owlCarousel({
          loop: true,
          margin: 20,
          dots: true,
          nav: true,
          responsive: {
            0: { items: 1 },
            600: { items: 3 },
            1000: { 
              items: id === "#owl-carousel2" || id === "#threteen" ? 1 : 3 
            }
          }
        });
      }
    });

    // Gauges (circular progress bars)
    const gauges = document.querySelectorAll(".gauge");
    gauges.forEach(gauge => {
      const percentage = gauge.getAttribute("data-percentage");
      const countText = gauge.getAttribute("data-count");
      const circle = gauge.querySelector("circle.progress");
      const number = gauge.querySelector(".number");

      const radius = 52;
      const circumference = 2 * Math.PI * radius;
      circle.style.strokeDasharray = `${circumference}`;
      const offset = circumference - (percentage / 100) * circumference;
      circle.style.strokeDashoffset = offset;

      // Animate number
      const target = parseInt(countText.replace("+", "").replace("k", "000"));
      let current = 0;
      const duration = 1000;
      const step = Math.ceil(target / (duration / 20));

      function updateCount() {
        current += step;
        if (current >= target) {
          number.textContent = countText;
        } else {
          number.textContent = `+${Math.floor(current / 1000)}k`;
          requestAnimationFrame(updateCount);
        }
      }
      updateCount();
    });

    // Cleanup on unmount
    return () => {
      accordianItemHeaders.forEach(header =>
        header.replaceWith(header.cloneNode(true))
      );
      carousels.forEach(id => $(id).trigger('destroy.owl.carousel'));
    };
  }, []);
};
